import {
    SET_PROPERTY_FILE_CONTEXT_MENU,
    SET_PROPERTY_SHARE_FILE,
    SET_PROPERTY_FILE_PATH,
    SET_PROPERTY_JSTREE_STATUS,
    REMOVE_PROPERTY_JSTREE_STATUS
} from '../../types';

const initialState = {
    ContextMenu: [],
    ShareFile: '',
    FilePath: {},
    JsTreeStatus: { uploaded: false }
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_PROPERTY_FILE_CONTEXT_MENU:
            return {
                ...state,
                ContextMenu: [...payload]
            };
        case SET_PROPERTY_SHARE_FILE:
            return {
                ...state,
                ShareFile: payload
            };
        case SET_PROPERTY_FILE_PATH:
            return {
                ...state,
                FilePath: payload
            };
        case SET_PROPERTY_JSTREE_STATUS:
        case REMOVE_PROPERTY_JSTREE_STATUS: {
            const { name, value } = payload;
            return {
                ...state,
                JsTreeStatus: {
                    ...state.JsTreeStatus,
                    [name]: value
                }
            };
        }
        default:
            return state;
    }
}